import React from 'react';
import { Plus } from "assets/icons";
import Button from "components/button";
import ClockGlyph from "components/emptyState/ClockGlyph";
import DrawnGlyph from "components/emptyState/DrawnGlyph";
import {useNavigate} from "react-router-dom";
import qrCodeImage from "assets/images/qrcode-app.svg";
import UseContext from "hooks/useContext";


// `compact`: inside a box (a list, a form step), no full-screen height to centre in.
const EmptyStateCompany = ({type, onAction, compact = false, children, ...props}) => {
    const navigate = useNavigate()
    const {setPage, setSelectedMissionTemplate} = UseContext()
    const handleCreateMission = () => {
        setSelectedMissionTemplate?.(null)
        setPage?.(3)
        navigate('/missionTemplates')
    }
    // Animated glyph in the grey badge, as in the temp worker app (EmptyState + DrawnGlyph).
    const glyph = {
        'mission_create': <DrawnGlyph name="fileText"/>,
        'mission_done': <DrawnGlyph name="badgeCheck"/>,
        'mission_in_progress': <DrawnGlyph name="inbox"/>,
        'mission_soon': <DrawnGlyph name="inbox"/>,
        'mission_search': <DrawnGlyph name="searchX"/>,
        'mission_invitation': <DrawnGlyph name="searchX"/>,
        'job_post_template': <DrawnGlyph name="star"/>,
        'contract': <DrawnGlyph name="badgeCheck"/>,
        'contract_sign': <DrawnGlyph name="penTool"/>,
        'time_sheet': <ClockGlyph/>,
        'time_sheet_litige': <ClockGlyph/>,
        'time_sheet_check': <ClockGlyph/>,
        'invoices_nopay': <DrawnGlyph name="receiptText"/>,
        'invoices_pay': <DrawnGlyph name="receiptText"/>,
        'coming': <DrawnGlyph name="hourglass"/>,
        'schedule': <DrawnGlyph name="calendarX"/>,
        'schedule_missing': <DrawnGlyph name="calendarX"/>,
    }

    const title = {
        'mission_done': 'Aucune mission terminées',
        'mission_in_progress': 'Aucune mission en cours',
        'mission_soon': 'Aucune mission prochainement',
        'mission_search': 'Pas de missions disponibles',
        'job_post_template': 'Pas de fiche de poste',
        'time_sheet': 'Aucun relevé d\'heure à compléter',
        'time_sheet_litige': 'Aucun relevé d\'heure en litige',
        'time_sheet_check': 'Aucun relevé d\'heure vérifié',
        'contract':'Aucun contrat signé disponible',
        'contract_sign':'Aucun contrat à signer disponible',
        'invoices_nopay': 'Aucune facture à régler',
        'invoices_pay':'Aucune facture réglée',
        'coming':'Fonctionnalité a venir',
        'desktop':'Jobbiz n\'est pas encore optimisée pour cette taille d\'écran',
        'schedule': 'Pas de planning pour cette mission',
        'schedule_missing': 'Planning non disponible',
        'mission_invitation': 'Aucun intérimaire à inviter',
    }
    const description = {
        'mission_create':'Vous vous apprêtez à créer une mission',
        'mission_done': 'Vous n\'avez pas de mission terminées, les missions étant déjà passées s\'afficheront ici.',
        'mission_in_progress': 'Vous n\'avez pas de mission en cours disponible pour le moment',
        'mission_soon': 'Vous n\'avez pas de mission à venir, les missions n\'ayant pas encore débutées s\'afficheront ici.',
        'job_post_template': 'Les fiches de poste vous permettent de créer vos missions plus rapidement.',
        'contract': 'Il n\'y a pas de contrats à signer disponible pour le moment.',
        'contract_sign':'Il n\'y a pas de contrats signé disponible pour le moment.',
        'time_sheet': 'Il n\'y a pas de relevés d\'heures à vérifier disponibles pour le moment.',
        'time_sheet_litige':'Il n\'y a pas de relevés d\'heures en litige disponibles pour le moment.',
        'time_sheet_check':'Il n\'y a pas de relevés d\'heures vérifié disponibles pour le moment.',
        'invoices_nopay': 'Il n\'y a pas de factures à régler disponible pour le moment.',
        'invoices_pay':'Il n\'y a pas de factutre réglée  disponible pour le moment.',
        'coming':'Oops, il n\'y a pas encore la fonctionnalité pour le moment, un peu de patience',
        'desktop':'Pour profiter d\'une expérience optimale, nous vous recommandons de télécharger l\'application mobile Jobbiz Pro.',
        'schedule': 'L\'intérimaire ne verra que les dates de la mission, sans horaires. Activez le planning pour définir les horaires de chaque jour.',
        'schedule_missing': 'Pas de planning disponible pour cette mission',
        'mission_invitation': 'Pas d\'intérimaire à inviter pour le moment',
    }

    // Liens vers les stores (à remplacer par les vrais liens)
    const appStoreLinks = {
        ios: process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com/app/jobbiz',
        android: process.env.REACT_APP_ANDROID_STORE_URL || 'https://play.google.com/store/apps/details?id=com.jobbiz',
    }

    const button={
        'mission_soon': <div className={'my-3'}><Button color={'SECONDARY'} size={'LG'} onClick={handleCreateMission}>Créer une mission</Button></div>,
        'mission_in_progress': <div className={'my-3'}><Button color={'SECONDARY'}
                                                               size={'LG'}
                                                               onClick={handleCreateMission}>Créer une mission</Button></div>,
        'mission_done': <div className={'my-3'}><Button color={'SECONDARY'} size={'LG'} onClick={handleCreateMission}>Créer une mission</Button></div>,
        'schedule': onAction ? (
            <div className={'my-3'}>
                <Button color={'SECONDARY'} size={'LG'} onClick={onAction}>Activer le planning</Button>
            </div>
        ) : null,
        'job_post_template': (
            <div className={'my-3'}>
                <Button
                    color={'SECONDARY'}
                    size={'LG'}
                    onClick={() => (onAction ? onAction() : navigate('/missionTemplates/create'))}
                >
                    <div className="flex items-center gap-2">
                        <Plus wh={14} color={'#374151'}/>
                        <div>Créer une fiche de poste</div>
                    </div>
                </Button>
            </div>
        ),
    }

    // Rendu spécial pour le type 'desktop' avec QR code et boutons
    if (type === 'desktop') {
        return (
            <>
                <div className={'max-w-[535px] my-16 mx-auto text-center'}>
                    {/* QR Code à la place de l'icône */}
                    <div className={'flex justify-center my-6'}>
                        <img 
                            src={qrCodeImage} 
                            alt="QR Code pour télécharger l'application mobile" 
                            className={'w-64 h-64 border border-gray-200 rounded-lg p-2 bg-white'}
                        />
                    </div>
                    <div className={'!font-medium ft-xl color-gray-700'}>
                        {title[type]}
                    </div>
                    <div className={'font-normal ft-b mt-2 text-[#757575]'}>
                        {description[type]}
                    </div>
                    <div className={'mt-8 flex flex-col items-center gap-6'}>
                        {/* Boutons iOS et Android */}
                        <div className={'flex flex-col sm:flex-row gap-4 justify-center items-center'}>
                            <a 
                                href={appStoreLinks.ios} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className={'inline-block'}
                            >
                                <Button color={'PRIMARY'} size={'LG'}>
                                    <div className={'flex items-center gap-2'}>
                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                                        </svg>
                                        <span>Télécharger pour iOS</span>
                                    </div>
                                </Button>
                            </a>
                            <a 
                                href={appStoreLinks.android} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className={'inline-block'}
                            >
                                <Button color={'PRIMARY'} size={'LG'}>
                                    <div className={'flex items-center gap-2'}>
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                            <path d="M12 8V4H8"/>
                                            <rect width="16" height="12" x="4" y="8" rx="2"/>
                                            <path d="M2 14h2"/>
                                            <path d="M20 14h2"/>
                                            <path d="M15 13v2"/>
                                            <path d="M9 13v2"/>
                                        </svg>
                                        <span>Télécharger pour Android</span>
                                    </div>
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div className={`mx-auto flex max-w-[535px] flex-col items-center justify-center text-center ${compact ? 'py-8' : 'min-h-[60vh] py-16'}`}>
                {glyph[type] && (
                    <div className={'relative mb-5 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100 text-gray-400'}>
                        {glyph[type]}
                    </div>
                )}
                <div className={'!font-medium ft-b text-gray-900'}>
                    {title[type]}
                </div>
                <div className={'font-normal ft-sm !leading-5 mt-2 text-[#757575]'}>
                    {description[type]}
                </div>
                <div className={'flex'}>
                    <div className={'mx-auto'}>
                        {button[type]}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmptyStateCompany;
